import React from "react";
import MarketingShell, { Section } from "@/components/MarketingShell";

export default function Terms() {
  return (
    <MarketingShell title="Terms of Service" subtitle="Last updated June 2026">
      <p>By creating an account or using Local CiteHub, you agree to these Terms of Service.</p>

      <Section heading="The service">
        <p>Local CiteHub helps you manage business information, generate ready-to-paste listing content, and track submission status across directories and AI platforms. Some directories require you (or our team, on eligible plans) to submit listings directly; we do not control third-party approval times or policies.</p>
      </Section>

      <Section heading="Subscriptions & billing">
        <p>Access requires a paid subscription. Plans and prices are shown on our pricing page and at checkout, and are billed via Stripe on a recurring basis until canceled. You authorize us to charge your payment method for each billing period.</p>
      </Section>

      <Section heading="Acceptable use">
        <p>You agree to provide accurate business information and to use the service in compliance with the policies of the directories and review platforms you list on — including their rules on authentic reviews. You are responsible for the content you submit.</p>
      </Section>

      <Section heading="Cancellation">
        <p>You may cancel anytime from your account. See our <a href="/refund" className="text-[#0055FF] font-semibold hover:underline">Cancellation & Refund Policy</a> for details.</p>
      </Section>

      <Section heading="Disclaimer & liability">
        <p>The service is provided "as is". We do not guarantee rankings, approvals, or specific results from any directory or AI platform. To the maximum extent permitted by law, our liability is limited to the amount you paid in the prior three months.</p>
      </Section>

      <Section heading="Changes">
        <p>We may update these terms; material changes will be communicated. Continued use after changes constitutes acceptance.</p>
      </Section>
    </MarketingShell>
  );
}
